import type { ShapeData } from '@/lib/shapes/types/shape-data'

/** The frame-and-path fields a node edit changes — what it writes back and records for undo. */
export type PathGeometry = Pick<ShapeData, 'x' | 'y' | 'width' | 'height' | 'path' | 'pathCommands'>

/** A shape's node-edit geometry: its frame plus its path, as one patch. */
export function pickPathGeometry(shape: PathGeometry): PathGeometry {
  return {
    x: shape.x,
    y: shape.y,
    width: shape.width,
    height: shape.height,
    path: shape.path,
    pathCommands: shape.pathCommands,
  }
}
